export interface DealFileReference {
  contentType: string;
  filename: string;
  gid: string;
}

export type DealFile = File | DealFileReference;

export function isFileReference(file: DealFile): file is DealFileReference {
  return !(file instanceof File);
}

export interface Options {
  dealType: { label: string; value: string }[];
  stage: { label: string; value: string }[];
  users?: Record<string, unknown>[];
}

export interface Paths {
  attachments: string;
  buildDealWithAi: string;
  dealCreationFields: string;
  newDeal: string;
}

export interface StageConfig {
  key: string;
  label: string;
}

export interface Config {
  features: { requiredTasks?: boolean } & Record<string, boolean>;
  forUser: {
    admin?: boolean;
    adminedOfficeIds?: number[];
    apexAdmin?: boolean;
    id: number;
  };
  options: Pick<Options, 'dealType' | 'users'>;
  paths: Paths;
  stagesConfig: Record<string, StageConfig>;
}
